module.exports = "<div ng-mouseenter=\"enableTrialModal = true\">\n\n    <div class=\"store\">\n\n        <div ng-if=\"ShowPrimePage\">\n            <prime-page></prime-page>\n        </div>\n\n        <!-- <div ng-if=\"ShowOODiskImagePage\">\n            <oo-diskimage-page></oo-diskimage-page>\n        </div> -->\n    </div>\n\n    <store-comparison ng-if=\"showComparison\"></store-comparison>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./scripts/controllers/dashboard/body/content/store/store.html
// module id = 4sKI
// module chunks = 0